import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllPartnerRolesService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const partnerId = +urlQueries["partner-id"] || "";

  const allPartnerRolesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PARTNER_ROLE,
      debouncedQuery,
      page,
      per_page,
      partnerId,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PARTNER_ROLE,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[partner_id]": partnerId,
          page,
          per_page,
          include: "partner",
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allPartnerRolesService },
    states: { searchQuery, setSearchQuery },
  };
};
